import * as z from "zod";

const deliveryAnalyticsV2FilterOptions = z.object({
  carriers: z.array(z.string()),
  carrierServices: z.array(z.string()),
  states: z.array(z.string()),
  countries: z.array(z.string()),
  // `SALES_CHANNEL` only exists on the v2 mart, so this is populated only for
  // v2 teams. Its absence (vs. an empty array) is the signal the merchant app
  // uses to hide the Sales channel filter dimension on the v1 path.
  salesChannels: z.array(z.string()).optional(),
});

export type DeliveryAnalyticsV2FilterOptions = z.infer<
  typeof deliveryAnalyticsV2FilterOptions
>;

export const getDeliveryAnalyticsV2FilterOptions = {
  name: "getDeliveryAnalyticsV2FilterOptions",
  input: z.object({ startDate: z.date(), endDate: z.date() }),
  output: deliveryAnalyticsV2FilterOptions,
};
